module.exports = __webpack_public_path__ + "static/media/set_shared.b252b888.svg";